import { shuffle } from 'lodash-es';

const PINNED_LAST = ['Other', 'No reason given'];

const isPinned = (reason, label) => PINNED_LAST.includes(label(reason));

export const shuffleReasons = (reasons, label = (reason) => reason) => [
  ...shuffle(reasons.filter((reason) => !isPinned(reason, label))),
  ...reasons.filter((reason) => isPinned(reason, label)),
];
